import { useCallback, useState } from "react";
import { getUserRepositories } from "../api";
import { useToast } from "./use-toast";

export const useRepositories = (defaultRepoSlug = "") => {
  const [repositories, setRepositories] = useState([]);
  const [selectedRepository, setSelectedRepository] = useState(
    defaultRepoSlug || ""
  );
  const [viewAllRepos, setViewAllRepos] = useState(!defaultRepoSlug);
  const [isLoadingAllRepos, setIsLoadingAllRepos] = useState(false);
  const [error, setError] = useState(null);
  const { toast } = useToast();

  const fetchRepositories = useCallback(async (workspace) => {
    try {
      const repos = await getUserRepositories(workspace);
      // Sort repositories alphabetically
      repos.sort((a, b) => a.name.localeCompare(b.name));
      setRepositories(repos);

      // If defaultRepoSlug exists in repos, select it
      if (
        defaultRepoSlug &&
        repos.some((repo) => repo.slug === defaultRepoSlug)
      ) {
        setSelectedRepository(defaultRepoSlug);
        setViewAllRepos(false);
      }

      return repos;
    } catch (err) {
      setError("Failed to load repositories");
      toast({
        title: "Error",
        description: "Failed to load repositories",
        variant: "destructive",
      });
      throw err;
    }
  }, [defaultRepoSlug, toast]);

  const handleRepositoryChange = (repo) => {
    if (repo === "__all__") {
      setSelectedRepository("");
      setViewAllRepos(true);
    } else {
      setSelectedRepository(repo);
      setViewAllRepos(false);
    }
    return viewAllRepos;
  };

  return {
    repositories,
    selectedRepository,
    setSelectedRepository,
    viewAllRepos,
    setViewAllRepos,
    isLoadingAllRepos,
    setIsLoadingAllRepos,
    error,
    fetchRepositories,
    handleRepositoryChange,
  };
};
